module.exports = __webpack_public_path__ + "static/media/scan0487.33da80f2.jpg";